import { render, staticRenderFns } from "./IonlineDataUsage.vue?vue&type=template&id=8d8b8758&scoped=true&"
import script from "./IonlineDataUsage.vue?vue&type=script&lang=js&"
export * from "./IonlineDataUsage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d8b8758",
  null
  
)

export default component.exports